module.exports = __webpack_public_path__ + "media/components/VendingCart/assets/extensions-thumbnail/none-c9fdff33f68656f6107437d0f20f2e60.png";